
<form (ngSubmit)="onSubmit()" #forgotPasswordForm="ngForm">
  <div class="container mt-5">
    <div class="row d-flex justify-content-center">
      <div class="col-md-6">
        <div class="card px-5 py-5" id="form1">
          <div class="form-data" v-if="!submitted">
            <div class="forms-inputs mb-4">
              <span>Confirmation Code</span>
              <input type="password" id="txtConfirmationCode" name="txtConfirmationCode" class="form-control form-control-lg"
                placeholder="Confirmation Code" required [(ngModel)]="forgotPassword.confirmationCode" #txtConfirmationCode="ngModel" />
            </div>
            <div class="forms-inputs mb-4">
              <span>New Password</span>
              <input type="password" id="txtPassword" name="txtPassword" class="form-control form-control-lg"
                placeholder="Password" required [(ngModel)]="forgotPassword.password" #txtPassword="ngModel" pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%&*])[A-Za-z\d!@#$%&*]{8,}$" />
            </div>
            <div class="forms-inputs mb-4">
              <span>Confirm Password</span> <input type="password" id="txtCfrmPassword" name="txtCfrmPassword" class="form-control form-control-lg"
              #txtCfrmPassword="ngModel" placeholder="Password" required [(ngModel)]="forgotPassword.confirmPassword" pattern="{{txtPassword.value}}" />
          </div>
          @if (txtConfirmationCode.invalid && (txtConfirmationCode.dirty || txtConfirmationCode.touched)) {
            <div>
              @if (txtConfirmationCode.errors?.['required']) {
                <div> Password is required </div>
              }
            </div>
          }
          @if (txtPassword.invalid && (txtPassword.dirty || txtPassword.touched)) {
            <div>
              @if (txtPassword.errors?.['required']) {
                <div> Password is required </div>
              }
              @if (txtPassword.errors?.['pattern']) {
                <div> Password should contain minimum 1 Uppercase letter, 1 lowercase letter, 1 digit and any 1 of these specials characters !&#64;#$%&* and minimum of 8 characters </div>
              }
            </div>
          }
          @if ( txtCfrmPassword.invalid && (forgotPasswordForm.submitted || txtCfrmPassword.touched)) {
            <div>
              @if (txtCfrmPassword.errors?.['required']) {
                <div> Confirm password is required. </div>
              }
              @if (txtCfrmPassword.errors?.['pattern']) {
                <div> Password & Confirm Password does not match.</div>
              }
            </div>
          }
          <div class="mb-3">
            <button [disabled]="(txtPassword.invalid || txtCfrmPassword.invalid)" type="submit" class="btn btn-primary btn-lg"
              style="padding-left: 2.5rem; padding-right: 2.5rem;">
              Change Password
            </button>
          </div>
          <div>
            {{errorMessage}}
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
</form>
